import React from 'react';
import Css from './ProjectsArea.module.css';
import Card from './projectCards/Card';

export default function ProjectsArea() {
  let array = [
    {
    id: "1",
    name: "Zippy",
    img: "https://i.ibb.co/Z6YnJ9D/zippy.png",
    url : "https://zippy-zip.netlify.app/",
    description : "Food ordering web app created using React.js, Css, Node.js, MongoDb."
  },
  {
    id: "2",
    name: "PhoneArena",
    img: "https://i.ibb.co/5nP2XxQ/phone-Arena.png",
    url : "https://phonearena.netlify.app/",
    description : "A web app that gives all info. about phones, created using React.js, Css, Node.js, MongoDb  "
  },
  {
    id: "3",
    name: "EmojiPedia",
    img: "https://i.ibb.co/hWqNKpB/emoji-Pedia-1.jpg",
    url : "https://emojii-pedia.netlify.app/",
    description : "A simple emojis guide created using React.js."
  },
  {
    id: "4",
    name: "To Do List",
    img: "https://i.ibb.co/gyJpnqX/todo.png",
    url : "https://to-do-list-2217.herokuapp.com/",
    description : "To Do List web app, created using EJS, Css, JavaScript, Node.js, MongoDb."
  },
  {
    id: "5",
    name: "Secret Keeper",
    img: "https://i.ibb.co/sRfTjFs/secret-keeperr.png",
    url : "https://secrets-keeper-yeh.herokuapp.com/",
    description : "Secret Kepper web app, created using EJS, Css, Node.js, Express.js, MongoDb, Passport.js."
  },
  {
    id : "6",
    name: "Daily Journal",
    img: "https://i.ibb.co/X22yFYt/blog.jpg",
    url : "https://daily-jaurnal.herokuapp.com/",
    description : "A blogging app created using EJS, Bootstrap, Css, MongoDb"
  },
  {
    id: "7",
    name: "Repeat It",
    img: "https://i.ibb.co/kx7g2Dc/repeater.png",
    url : "https://shweta2217.github.io/textRepeater/",
    description : "Text Repeater & Reverser web app, created using Html, Css, JavaScript."
  },
  {
    id: "8",
    name: "Tic Tac Toe",
    img: "https://i.ibb.co/1RJF3Gz/tic-tac-toe.png",
    url : "https://shweta2217.github.io/tic_tac_toe/",
    description : "Tic-Tac-Toe web game, created using Html, Css, JavaScript."
  },
  {
    id: "9",
    name: "meoow",
    img: "https://i.ibb.co/zrmpgnz/meoow.png",
    url : "https://shweta2217.github.io/meoow/",
    description : "Cat adoption website created using Html, Css, Bootstrap."
  },
  {
    id: "10",
    name: "Calculator",
    img: "https://i.ibb.co/p0Dv0V0/calculator.png",
    url : "https://shweta2217.github.io/calculator/",
    description : "Calculator web app created using Html, Css, JavaScript. "
  },  
   {
     id: "11",
     name: "Drum Kit",
     img: "https://i.ibb.co/zJNzNRx/drum-kit.png",
     url : "https://shweta2217.github.io/drum-kit/",
     description : "Drum sound playing web app created using Html, Css, JavaScript. "
   },
  {
    id: "12",
    name: "SoundPlayGround",
    img: "https://i.ibb.co/JC7pDN1/soundplayground.png",
    url : "https://shweta2217.github.io/Sound_PlayGround/",
    description : "Diffrent-2 sounds playing web app created using Html, CSS, JavaScript."
  },
  {
    id : "13",
    name: "foodies",
    img: "https://i.ibb.co/tshQ9vN/foodies.png",
    url : "https://shweta2217.github.io/foodies/",
    description : "Food odering website created using Html, Css, bootstrap."
  },
  {
    id : "14",
    name: "Dicee",
    img: "https://i.ibb.co/3CQ6npy/Dicee-1.jpg",
    url : "https://shweta2217.github.io/Dicee/",
    description : "Dice rolling game created using Html, Css, JavaScript."
  },
];

  function setCards(array) {
    return array.map((item)=>{
      return <span key={item.id+"P"}><Card item={item}/></span>
    })
  }
  return <div id='Work' className={Css.MainWorkContainer}>
      <h1 className={Css.MainHeading}>My Work</h1>
      <div className={Css.cardContainer}>
            {setCards(array)}
      </div>
  </div>;
}
